module.exports = __webpack_public_path__ + "static/media/045-basket-white.6c5a0e20.svg";